// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","535":"login","685":"register","770":"routes","995":"collects-create"}[chunkId] || chunkId) + "." + {"177":"028ece69","482":"72530ee6","535":"cb462a45","685":"0b77eca7","708":"42ac622d","748":"dcf268ea","770":"eb6bd50f","995":"9f1dff32"}[chunkId] + ".js";
};